import React from 'react';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';
const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const Icon = styled.svg`
  g {
    transform-origin: 50% 50%;
    .active &,
    .idle & {
      animation: ${spin} 5s linear infinite;
    }
  }
  .cls-1,
  .cls-3 {
    fill: none;
  }

  .cls-1,
  .cls-2,
  .cls-3 {
    stroke: #fff;
  }

  .cls-1,
  .cls-2 {
    stroke-width: 2px;
  }

  .cls-2 {
    fill: #fff;
  }

  .cls-3 {
    stroke-linecap: square;
  }
`;

export const WaterTreatmentPlantIcon = () => {
  return (
    <Icon viewBox='0 0 72 72'>
      <g id='water_treatment_icon' data-name='water treatment icon'>
        <circle id='Oval-5' className='cls-1' cx='36' cy='36' r='35' />
        <circle
          id='Oval-5-2'
          data-name='Oval-5'
          className='cls-2'
          cx='36'
          cy='36'
          r='7'
        />
        <path id='Line' className='cls-3' d='M36,16V56' />
      </g>
    </Icon>
  );
};
